import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { subscribeTable } from '../lib/realtime';
import type { WalletItem } from '../lib/types';

export function useWalletItems(driverId: string | undefined) {
  const [items, setItems] = useState<WalletItem[]>([]);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    if (!driverId) return;
    const { data } = await supabase
      .from('wallet_items')
      .select('*')
      .eq('driver_id', driverId)
      .order('kind');
    setItems((data ?? []) as WalletItem[]);
    setLoading(false);
  }, [driverId]);

  useEffect(() => {
    if (!driverId) {
      setLoading(false);
      return;
    }
    refetch();
    const unsub = subscribeTable('wallet_items', refetch, `driver_id=eq.${driverId}`);
    return unsub;
  }, [driverId, refetch]);

  return { items, loading, refetch };
}
